
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import eventBus from '@/utils/eventBus';

import GroupCustomer from './GroupCustomer.vue';
import GroupAddress from './GroupAddress.vue';
import GroupFault from './GroupFault.vue';
import GroupTag from './GroupTag.vue';
import DialogDepartment from '@/components/DeptLev/index.vue';
import GroupCombine from './GroupCombine.vue';

import DialogGroupStep2 from './GroupDialogStep2.vue';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import DialogDept from '@/components/DeptDialog/index.vue';
import DialogScheduling from '@/components/DialogScheduling/index.vue';

import DialogSetShifts from '@/views/staff/components/setShifts.vue';
import DialogSetStaff from '@/views/staff/components/setStaff.vue';

import { getDepartmentList } from '@/api/company';
import { getWorkUser } from '@/api/users';
import { addGroupPush, editGroupPush, groupPushScheduling } from '@/api/group';
import { getSchedulingList, getSchedulingShiftsUser, schedulingShiftsUser, delGroupScheduling, delSchedulingShifts, startScheduling } from '@/api/groupScheduling';
import { getService } from '@/api/service';

@Component({
  name: 'GroupStep2',
  components: {
    GroupCustomer,
    GroupAddress,
    GroupFault,
    GroupTag,
    DialogDepartment,
    GroupCombine,

    DialogGroupStep2,
    DialogDept,
    DialogScheduling,

    DialogSetShifts,
    DialogSetStaff
  },
  filters: {
    seletTitle(value: string) {
      let title = ''
      switch (parseInt(value)) {
        case 1:
          title = '选择客户';
          break
        case 2:
          title = '选择地址';
          break
        case 4:
          title = '选择故障现象';
          break
        case 6:
          title = '选择标签';
          break
        case 9:
          title = '选择部门';
          break
        case 7:
          title = '组合条件一';
          break
      }
      return title;
    }
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  selectedGroupStepVisible!: Boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isDefault!: Boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  groupPushType!: any;

  @Prop({
    type: Object,
    default: () => ({})
  })
  editGroupStep!: any;

  private searchParams: any = {}
  // private tableData:any = [];
  private editData:any = {};

  private selcetCustomer:any=[];
  private selectAddress:any=[];
  private selectFault: any=[];
  private selectTags:any=[];
  private selectDepartment:any=[]
  private groupCombineVisible = []


  // private dialogSelectedVisible=false
  // private selectedDeptvisible = false;

  private activeNmuber = 0

  private isHaveSchedulings=false;
  private isHaveServicer=false;

  private tableSchedulingData: any = []
  // 分派处理  - 部门
  private searchDept: any = {
    name: ''
  }
  private deptLoading = false;
  private page:number=1;
  private pageCount:number=1;
  private deptTableData: any = []
  private selectedData:any = {}
  // 获取 工程师
  private engLoading = false;
  private engPage:number=1
  private engPageCount:number=1;
  private engTableData: any = []

  private selectedUserId:any=[];
  private selectedUserList:any=[];

  private selectedService:any={};
  private selectedServiceList: any = [];

  created() {
    // 编辑群组
    if (this.editGroupStep) {
      if (this.editGroupStep.id) {
        this.pushId = this.editGroupStep.id;
      }
      this.pushNameData.pushName = this.editGroupStep.group_name;
      if (this.editGroupStep.group_push) {
        if (this.groupPushType.type === 1) { // 客户
          this.selcetCustomer = this.editGroupStep.group_push.customer_list;
        } else if (this.groupPushType.type === 2) { // 地址
          this.selectAddress = this.editGroupStep.group_push.address_list;
        } else if (this.groupPushType.type === 4) { // 故障现象
          this.selectFault = this.editGroupStep.group_push.fault_phenomenon_list;
        } else if (this.groupPushType.type === 6) { // 选择标签
          this.selectTags = this.editGroupStep.group_push.tag_list;
        } else if (this.groupPushType.type === 9) { // 选择部门
          this.selectDepartment = this.editGroupStep.group_push.department_list;
        }
      }
    }
    if (this.editGroupStep && this.editGroupStep.group_push && this.editGroupStep.group_push.engineer_json) {
      this.radioWay = 2
    } else if (this.editGroupStep && this.editGroupStep.group_push && parseInt(this.editGroupStep.group_push.transfer_servicer_company_id)>0){
      this.radioWay = 4
      this.getService();
    }else if (parseInt(this.editGroupStep.sub_type) === 1) {
      this.radioWay = 3
      this.subType = 1
    } else {
      this.subType = 0
      this.radioWay = 1
    }

    this.getDeptList();
    this.isHaveSchedulings = checkPermissionCompany(UserModule.getCompanyId, Type.Schedulings);
    this.isHaveServicer =   checkPermissionCompany(UserModule.getCompanyId, Type.GroupPushCombine) && checkPermissionCompany(UserModule.getCompanyId, Type.SERVICER_COMPANY) &&  checkPermissionCompany(UserModule.getCompanyId, Type.ORDER_TRANSFER);
    
  }

  //合作维修方
  private getService() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: 1,
      size: 100
    };
    getService(params)
      .then((res: any) => {
        if (res.data) {
          this.selectedServiceList = res.data.list;
          this.setService(this.selectedServiceList);
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private selectedServiceChange(val: any) {
    this.selectedService = val;
  }
  private setService(list:any) {
    if (this.editGroupStep.group_push && this.editGroupStep.group_push.transfer_servicer_company_id) {
      if (list && list.length > 0) {
        for (let item of list) {
          if (this.editGroupStep.group_push.transfer_servicer_company_id === item.servicer_company_id) {
            this.selectedService = item;
            return;
          }
        }
      }
    }
  }

  // 分派部门 列表
  private getDeptList() {
    this.deptLoading = true;
    let params: any = {
      page: this.page,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      type: '9', // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
      dept_type: 2 // 部门类型 1报修部门 2服务部门
    };
    if (this.searchDept.name) {
      params.name = this.searchDept.name;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.pageCount = res.data.page_count;
        }
        if (this.page === 1) {
          this.deptTableData = res.data.list;
        } else {
          this.deptTableData = this.deptTableData.concat(res.data.list);
        }
        this.setDept(this.deptTableData);
        this.deptLoading = false;
      })
      .catch((err) => {
        this.deptLoading = false;
        let msg = err.msg;
      });
  }
  private setDept(list:any) {
    if (this.editGroupStep.group_push && this.editGroupStep.group_push.servicer_dept_id) {
      if (list && list.length > 0) {
        for (let item of list) {
          if (this.editGroupStep.group_push.servicer_dept_id === item.dept_id) {
            this.selectedData = item;
            //20241205 只有选择分派到工程师师才拉取工程师
            if(this.radioWay == 2){
              this.getWorkUser();
            }
            return;
          }
        }
      }
    }
  }
  private selectedDeptChange(val: any) {
    this.engPage = 1;
    this.selectedUserId = [];
    this.selectedUserList = [];
    if (this.radioWay === 2) {
      this.getWorkUser();
    }
    if (this.radioWay === 3) {
      this.add(this.pushNameData.pushName, this.subType);
    }
  }
  private getWorkUser() {
    const params: any = {
      dept_id: this.selectedData.dept_id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      page: this.engPage,
      size: 10
    };

    getWorkUser(params)
      .then((res: any) => {
        if (res.data) {
          if (this.engPage === 1) {
            this.engTableData = res.data.list;
          } else {
            this.engTableData = this.engTableData.concat(res.data.list);
          }
          //只有当前分派方式跟当前
          if(this.editGroupStep.group_push&&this.selectedData.dept_id===this.editGroupStep.group_push.servicer_dept_id){
            this.setSelectEng();
          }
          this.engPageCount = res.data.page_count;
        } else {
          if (this.engPage === 1) {
            this.engTableData = [];
          }
        }
      })
      .catch((err: any) => {
        if (this.engPage === 1) {
          this.engTableData = [];
        }
        let msg = err.msg;
      });
  }
  private setSelectEng() {
    if(this.editGroupStep.group_push&&this.editGroupStep.group_push.engineer_arr&&this.editGroupStep.group_push.engineer_arr.length>0){
      for(let item of this.editGroupStep.group_push.engineer_arr){
        let eng=this.selectedUserId.filter((uid:any)=>{
          return uid===item.engineer_user_id
        })
        if(!(eng&&eng.length>0)){
          this.selectedUserId.push(item.engineer_user_id);
          this.selectedUserList.push({
            user:{
              id:item.engineer_user_id,
              name:item.engineer_user_name
            }
          })
        }
      }
    }
    this.$forceUpdate();
  }
  private selectedEngChange(checked:boolean, val: any) {
    if(checked){
      let aa=this.selectedUserList.filter((ss:any)=>{
        return ss.user.id===val.user.id;
      })
      if(!(aa&&aa.length>0)){
        this.selectedUserList.push(val)
      }
    }else{
      let index=this.selectedUserList.findIndex((ss:any)=>{
        return ss.user.id===val.user.id;
      })
      if(index!==-1){
        this.selectedUserList.splice(index,1)
      }
    }
    
  }
  private engMore() {
    this.engPage = this.engPage + 1;
    this.getWorkUser();
  }
  private deptMore() {
    this.page = this.page + 1;
    this.getDeptList();
  }

  private searchHandle() {
    this.page = 1;
    this.getDeptList();
  }
  private selectPopData:any={};// 组合推单数据
  private radioWay = 1 // 分派处理方式
  private pushNameData: any = {
    pushName: ''
  }
  private pushId=''
  private subType:number = 0;// 是否推单至排班
  private radioWayHandle(val: number) {
    if (val === 1) {
      this.selectedUserId = [];
      this.selectedUserList = [];
      this.selectedService = {};
         //清部门
         this.selectedData = []

      this.getDeptList();
    }
    if (val === 2) {
      this.selectedService = {};

         //清部门
         this.selectedData = []

      this.getDeptList();
      this.getWorkUser();
    }
    if (val === 4) {
      this.selectedUserId = [];
      this.selectedUserList = [];
      //清部门
      this.selectedData = []
      this.getService();
    }
    
    if (val === 3) {
      this.selectedUserId = [];
      this.selectedUserList = [];
      this.selectedService = {};
      this.subType = 1;
      this.getDeptList();
      if (this.selectedData.dept_id) { // 先得有部门
        this.add(this.pushNameData.pushName, this.subType);
      } else {
        // 先选部门
        this.showErrorMsg('请选择部门')
      }
    } else {
      this.subType = 0
    }
  }
  private prevStep() {
    if (this.activeNmuber === 2) {
      this.activeNmuber = 1
    } else if (this.activeNmuber === 3) {
      this.activeNmuber = 2;// 把选中的数据  赋值到 组合推单数据里
      // if(this.selectPopData)
    } else {
      this.activeNmuber = 0
    }
  }
  private nextStep() {
    if (this.activeNmuber === 0) {
      (this.$refs.formPushName as any).validate((valid: any) => {
        if (valid) {
          this.activeNmuber = 1
        } else {
          return false;
        }
      });
    } else {
      if (this.groupPushType.type === 1) {
        if (!this.selcetCustomer || this.selcetCustomer.length < 1) {
          this.showErrorMsg('请选择客户');
          return;
        }
      } else if (this.groupPushType.type === 2) {
        if (!this.selectAddress || this.selectAddress.length < 1) {
          this.showErrorMsg('请选择地址');
          return;
        }
      } else if (this.groupPushType.type === 4) {
        if (!this.selectFault || this.selectFault.length < 1) {
          this.showErrorMsg('请选择故障现象');
          return;
        }
      } else if (this.groupPushType.type === 6) {
        if (!this.selectTags || this.selectTags.length < 1) {
          this.showErrorMsg('请选择标签');
          return;
        }
      } else if (this.groupPushType.type === 9) {
        if (!this.selectDepartment || this.selectDepartment.length < 1) {
          this.showErrorMsg('请选择部门');
          return;
        }
      }
      if (this.groupPushType.type === 7) {
        this.activeNmuber = 3
      } else {
        this.activeNmuber = 2
      }

      if (this.pushId && this.radioWay === 3) {
        this.add(this.editGroupStep.group_name, parseInt(this.editGroupStep.sub_type));
      }
    }
  }
  private confirmData() {
    //如果是分派至合作服务方 
    if(this.radioWay === 4 ){ 
      if(!this.selectedService || !this.selectedService.servicer_company_id) {
        this.showErrorMsg('请选择合作服务方');
        return;
      }
    }else {
      if(!this.selectedData || !this.selectedData.dept_id) {
        this.showErrorMsg('请选择部门');
        return;
      }
    }
    if (this.subType === 1) {
      this.groupFinishHandle()
    } else {
      this.add(this.pushNameData.pushName, this.subType);
    }
  }
  //目前存在的问题 只要选推到部门并排班 原来有部门或者选部门就会创建群组
  private add(name: any, subType:number) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      servicer_company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      servicer_company_name: UserModule.getCompanyName,
      group_type: this.groupPushType.addressType ? this.groupPushType.addressType : (this.groupPushType.type === 1) ? 0 : this.groupPushType.type,
      sub_type: subType, // 推单至排班
    };
    if (this.radioWay === 2 && !(this.selectedUserList && this.selectedUserList.length>0)) {
      this.showErrorMsg('请选择工程师')
      return
    }
    if (this.selectPopData && this.groupPushType.type === 7) { // 组合推单
      if (this.selectPopData.customer && this.selectPopData.customer.length > 0) {
        params.customer_list = JSON.stringify(this.selectPopData.customer);
      }
      if (this.selectPopData.address && this.selectPopData.address.length > 0) {
        params.address_list = JSON.stringify(this.selectPopData.address);
      }
      if (this.selectPopData.fault && this.selectPopData.fault.length > 0) {
        params.fault_phenomenon_list = JSON.stringify(this.selectPopData.fault);
      }
      if (this.selectPopData.tags && this.selectPopData.tags.length > 0) {
        params.tag_list = JSON.stringify(this.selectPopData.tags);
      }
      if (this.selectPopData.dept && this.selectPopData.dept.length > 0) {
        params.department_list = JSON.stringify(this.selectPopData.dept);
      }
      params.device_list = JSON.stringify(this.selectPopData.device);

      params.where_one = this.selectPopData.oneWhere;
      params.where_two = this.selectPopData.twoWhere;
    }

    if (this.selcetCustomer && (this.groupPushType.type === 1)) { // 选择客户
      if (this.selcetCustomer && this.selcetCustomer.length > 0) {
        params.customer_list = JSON.stringify(this.selcetCustomer);
      }
    }

    if (this.selectAddress && (this.groupPushType.type === 2)) { // 选择地址
      if (this.selectAddress && this.selectAddress.length > 0) {
        params.address_list = JSON.stringify(this.selectAddress);
      }
    }

    if (this.selectFault && (this.groupPushType.type === 4)) { // 选择故障现象
      if (this.selectFault && this.selectFault.length > 0) {
        params.fault_phenomenon_list = JSON.stringify(this.selectFault);
      }
    }

    if (this.selectFault && (this.groupPushType.type === 6)) { // 选择标签
      if (this.selectTags && this.selectTags.length > 0) {
        params.tag_list = JSON.stringify(this.selectTags);
      }
    }

    if (this.selectDepartment && (this.groupPushType.type === 9)) { // 选择部门
      if (this.selectDepartment && this.selectDepartment.length > 0) {
        params.department_list = JSON.stringify(this.selectDepartment);
      }
    }
    if (this.selectedService.servicer_company_id) {
      params.transfer_servicer_company_id = this.selectedService.servicer_company_id;
      params.transfer_servicer_company_name = this.selectedService.name;
    }
    if (this.selectedData.dept_id) {
      params.servicer_dept_id = this.selectedData.dept_id;
      params.servicer_dept_name = this.selectedData.name;
    }
    if (this.selectedUserList && this.selectedUserList.length>0) {
      let arr=[]
      for(let eng of this.selectedUserList){
        arr.push({
          engineer_user_id:eng.user.id,
          engineer_user_name:eng.user.name
        })
      }
      params.engineer_json=JSON.stringify(arr)
    }
    params.group_name = name;
    params.is_default_group = this.isDefault ? '1' : '0';

    if (this.pushId) {
      params.id = this.pushId;
      editGroupPush(params).then(res => {
        if (subType === 1) {
          this.groupData = {
            group_push_id: this.pushId,
            group_push_name: this.pushNameData.pushName
          };
          this.getAuthGroup();
        } else {
          this.showSuccessMsg((res as any).msg);
          this.close()
          this.$emit('selectedGroup');
          // this.selectedDeptvisible = false;
        }
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addGroupPush(params).then(res => {
        if (subType === 1) {
          if (res.data && res.data.group_cs) {
            this.pushId = res.data.group_cs.id;
          }
          this.groupData = {
            group_push_id: this.pushId,
            group_push_name: this.pushNameData.pushName
          };
          this.getAuthGroup();
        } else {
          this.showSuccessMsg((res as any).msg);
          this.close()
          this.$emit('selectedGroup');
          // this.selectedDeptvisible = false;
        }
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }

  private checkedCustomerChange(val:any) {
    this.selcetCustomer = val;
  }
  private addressSelectedChange(val: any) {
    this.selectAddress = val;
  }
  private checkedFaultChange(val:any) {
    this.selectFault = val;
  }
  private checkedTagChange(val:any) {
    this.selectTags = val;
  }
  private changeDeptChange(value:any) {
    this.selectDepartment = value;
  }

  private showThird() {
    this.activeNmuber = 2
  }
  private groupCombineNextVisible(val: any) {
    this.activeNmuber = 3
    this.selectPopData = val;// val 是返回的组合推单选择的 数据
    if (this.selectedData.dept_id) {
      this.groupData.group_push_id = this.pushId
      this.groupData.group_push_name = this.pushNameData.pushName
    }
    if (this.subType === 1) {
      this.getAuthGroup();
    }
  }
  private showSecond() {
    if (this.activeNmuber === 2) {
      this.activeNmuber = 1
    } else if (this.activeNmuber === 1) {
      this.activeNmuber = 0
    }
  }

  // 排班
  // private deptType=2
  // private deptSelected:any={};
  // private dialogResultSchedulingHandle:any={}
  // private departmentDialogClose(val:any) {
  //   this.departmentVisible = val;
  // }
  // private departmentSelected(val:any) {
  // this.deptSelected = val;
  // this.editGroupStep.servicer_dept_id = val.dept_id;
  // this.editGroupStep.servicer_dept_name = val.name;
  // this.add(this.pushNameData.pushName, this.isDefault, 1);
  // }

  // 分派至部门后并排班
  private currentPage=1;
  private listLoading=false;
  private pageSize=0;
  private groupSchedulingId=''
  private getAuthGroup() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.currentPage,
      group_push_id: this.groupData.group_push_id,
      group_push_name: this.groupData.group_push_name,
      is_group_push_list: 1,
      department_id: this.selectedData.dept_id,
      department_name: this.selectedData.name
    };
    getSchedulingList(params).then(res => {
      if (res.data && res.data.list && res.data.list.length > 0) {
        this.listLoading = false;
        this.pageSize = res.data.page_count;
        if (this.currentPage === 1) {
          this.tableSchedulingData = res.data.list;
        } else {
          this.tableSchedulingData = this.tableSchedulingData.concat(res.data.list);
        }
        if (res.data.list.length === 1) {
          this.groupSchedulingId = res.data.list[0].id;
          if (!res.data.list[0].child || res.data.list[0].child.length < 1) {
            this.addShiftsHandle(res.data.list[0]);
          }
          if (res.data.list[0].child.length === 1 && parseInt(res.data.list[0].child[0].shifts_user_count) < 1) {
            this.settingStaffHandle(res.data.list[0].child[0], res.data.list[0]);
          }
        }
      } else {
        this.pageSize = 0;
        this.tableSchedulingData = [];
      }
    }).catch(err => {
      this.pageSize = 0;
      this.tableSchedulingData = [];
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  private loadMore() {
    this.currentPage = this.currentPage + 1;
    this.getAuthGroup();
  }

  // 班次
  private itemData:any={}
  private shiftsOperate = 1
  private dialogSetStaffVisible = false;
  private dialogSetShiftsVisible = false

  private shiftsClose(val:any) {
    this.dialogSetShiftsVisible = val;
  }
  private confirm() {
    this.getAuthGroup();
  }
  private addShiftsHandle(val:any) {
    this.itemData = val;
    this.itemData.groupId = val.id;
    this.shiftsOperate = 1;
    this.dialogSetShiftsVisible = true;
  }
  private editShiftsHandle(val:any, val2:any) {
    this.itemData = val;
    this.itemData.groupId = val2.id;
    this.shiftsOperate = 2;
    this.dialogSetShiftsVisible = true;
  }
  private deleteShiftsHandle(val:any) {
    this.itemData = val;
    this.showConfirmMsg('确认删除该班次吗?', 3);
  }
  private showConfirmMsg(message: any, type:number) {
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.del(type);
    }).catch(() => {

    });
  }
  private del(type:number) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    switch (type) {
      case 1:
        pamars.id = this.itemData.id;
        delGroupScheduling(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 2:
        pamars.id = this.itemData.id;
        if (parseInt(this.itemData.state) === 1) {
          pamars.state = '0';
        } else {
          pamars.state = '1';
        }
        startScheduling(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 3:
        pamars.shifts_id = this.itemData.id;
        delSchedulingShifts(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
    }
  }

private selectUserData:any = [];
private settingStaffHandle(val: any, Prow:any) {
  this.itemData = val;
  this.itemData.dept_id = Prow.department_id;
  this.getSchedulingShiftsUser();
}
private getSchedulingShiftsUser() {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId
  };
  pamars.shifts_id = this.itemData.id;
  getSchedulingShiftsUser(pamars).then((res:any) => {
    if (res.data) {
      this.selectUserData = res.data.list;
    } else {
      this.selectUserData = [];
    }
    this.dialogSetStaffVisible = true;
  }).catch(err => {
    let msg = err.msg;
    this.selectUserData = [];
    this.dialogSetStaffVisible = true;
  });
}
private selectUser(val:any) {
  this.selectUserData = val;
  this.setUser(val);
}

private setUser(user:any) {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId
  };
  pamars.shifts_id = this.itemData.id;
  pamars.group_id = this.itemData.group_id;
  pamars.shifts_user = JSON.stringify(user);
  schedulingShiftsUser(pamars).then((res:any) => {
    this.showSuccessMsg(res.msg);
    this.getAuthGroup();
    this.dialogSetStaffVisible = false;
    // 添加群组 部门至推单  选择完人员 到此完成
  }).catch(err => {
    this.showErrorMsg(err.msg);
  });
}
private closeHandle(val: any) {
  this.dialogSetStaffVisible = val;
}
private groupFinishHandle() {
  let pamars:any = {};
  pamars.company_id = UserModule.getCompanyId;
  pamars.user_id = UserModule.getUserId;
  pamars.id = this.groupData.group_push_id;
  pamars.group_scheduling_id = this.groupSchedulingId;
  groupPushScheduling(pamars).then((res:any) => {
    this.showSuccessMsg(res.msg);
    this.close()
    this.$emit('selectedGroup');
  }).catch(err => {
    this.showErrorMsg(err.msg);
  });
}

// 排班
  private groupData:any={}
  // private dialogSchedulingConfirm(val:any) {
  // this.dialogSchedulingVisible = false;
  // this.departmentVisible = false;
  // this.dialogSelectedVisible = false;
  // this.getList();
  // }
  // private dialogSchedulingClose(val:boolean) {
  // this.dialogSchedulingVisible = val;
  // }

  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
